import React, { useEffect } from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { Query } from '../hooks/queries'
import { initializeAngularBroadcastEventListener } from './shared'
import { css } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      cacheTime: Infinity,
      retry: false,
      refetchOnWindowFocus: false
    }
  }
})

const devToolsCodeStyle = css`
  & code {
    color: ${theme.color.neutral50} !important;
    background-color: ${theme.color.neutral100} !important;
  }
`

export function wrapWithReactQuery(
  WrappedComponent: React.ComponentType,
  rootScope: any,
  renderDevTools = true
) {
  return function withReactQuery(props) {
    return (
      <ReactQueryWrapper
        WrappedComponent={WrappedComponent}
        rootScope={rootScope}
        renderDevTools={renderDevTools}
        {...props}
      />
    )
  }
}

const ReactQueryWrapper = ({
  WrappedComponent,
  rootScope,
  renderDevTools,
  ...rest
}) => {
  useEffect(() => {
    return initializeAngularBroadcastEventListener(
      rootScope,
      'org:switch',
      () => queryClient.clear()
    )
    // we only need to setup this callback once
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    return initializeAngularBroadcastEventListener(
      rootScope,
      'profile:loaded',
      () => queryClient.removeQueries([Query.CURRENT_USER_PROFILE])
    )
    // we only need to setup this callback once
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <QueryClientProvider client={queryClient}>
      <WrappedComponent {...rest} />
      {renderDevTools && (
        <ReactQueryDevtools
          initialIsOpen={false}
          panelProps={{ className: devToolsCodeStyle }}
        />
      )}
    </QueryClientProvider>
  )
}
